export const ANALYTICAL_JOURNEY_STAGES = Object.freeze([
  Object.freeze({
    id: "quantify",
    label: "Quantify",
    module: "Risk Quantification",
    route: "/risk-quantification",
  }),
  Object.freeze({
    id: "understand",
    label: "Understand",
    module: "Sensitivity Analysis",
    route: "/sensitivity",
  }),
  Object.freeze({
    id: "optimize",
    label: "Optimize",
    module: "Risk Investment Optimization",
    route: "/investment-optimization",
  }),
  Object.freeze({
    id: "synthesize",
    label: "Synthesize",
    module: "Portfolio Analysis",
    route: "/portfolio-analysis",
  }),
  Object.freeze({
    id: "propose",
    label: "Propose",
    module: "Portfolio Capital Strategy",
    route: "/decision-center",
  }),
]);

export function getAnalyticalJourneyStage(stageId) {
  return ANALYTICAL_JOURNEY_STAGES.find(({ id }) => id === stageId);
}
